import React from "react";
import LoadingSpinner from "views/Components/loadingSpinner";

const Finance = ({ finance }) => {
  const hasBankAccountNumber = Boolean(
    finance.bank &&
      typeof finance.bank.bank_account_no === "string" &&
      finance.bank.bank_account_no.trim(),
  );

  return (
    <div className="cw-finance-grid cw-finance-availability">
      <section className="cw-subsection cw-finance-status-item">
        <h3>Saved cards</h3>
        {finance.cardsLoading ? (
          <LoadingSpinner />
        ) : finance.cardsError ? (
          <div className="cw-tab-error" role="alert">
            {finance.cardsError}
          </div>
        ) : finance.cards.length ? (
          <p className="cw-status-active">Available</p>
        ) : (
          <p className="cw-status-inactive">Not available</p>
        )}
      </section>

      <section className="cw-subsection cw-finance-status-item">
        <h3>Bank account</h3>
        {finance.bankLoading ? (
          <LoadingSpinner />
        ) : finance.bankError ? (
          <div className="cw-tab-error" role="alert">
            {finance.bankError}
          </div>
        ) : hasBankAccountNumber ? (
          <p className="cw-status-active">Available</p>
        ) : (
          <p className="cw-status-inactive">Not available</p>
        )}
      </section>
    </div>
  );
};

export default Finance;
